import { graphql } from "@opensea/graphql"
import { getMediaPropsFromMediaFragment } from "@/components/collection/overview/utils"

export const TimelineContentBlockCarouselFragment = graphql(
  `
    fragment TimelineContentBlockCarousel on CollectionContentBlockModule {
      sections {
        __typename
        ... on TimelineContentBlock {
          title
          description
          date
          timelineMedia: media {
            ...MediaProps
          }
        }
      }
    }
  `,
  [getMediaPropsFromMediaFragment],
)
